import { Routes } from '@angular/router';
import { NotFoundPageComponent } from 'src/app/components/special-pages/not-found-page/not-found-page.component';

export const full: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('../../components/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '404',
    component: NotFoundPageComponent,
  },
];
